/**
 * 企业专区筛选项列表
 * @author tanglinxia
 * @since 22/05/06
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import debounce from '@fe/common/lib/debounce';
import clone from '@fe/common/lib/clone';
import cx from 'classnames';
import './store-filters-orgzone.less';

// 筛选项默认高度
const DEFAULT_ROW_HEIGHT = 43;
// 全部-fieldKey
const ALL_KEY = 'ALL';
// 默认分类groupId
const DEFAULT_FILTER = 'DEFAULT_FILTER';
// 最大显示行数
const MAX_FILTER_ROW = 8;

export default class StoreFiltersOrgZone extends Component {
  static propTypes = {
    filters: PropTypes.array,
    setFilters: PropTypes.func,
    selectedFilters: PropTypes.object,
  };
  constructor() {
    super();
    this.state = {
      isShowMore: false,
    };
  }

  componentDidMount() {
    // 调整屏幕大小时，`更多`按钮进行适配
    window.addEventListener('resize', debounce(this.checkIsFoldable, 300));
  }

  componentWillUnmount() {
    window.removeEventListener('resize', debounce(this.checkIsFoldable, 300));
  }

  componentDidUpdate(prevProps) {
    if (prevProps.filters !== this.props.filters) {
      this.checkIsFoldable();
    }
  }

  // 计算筛选项列表是否展示更多按钮
  checkIsFoldable = () => {
    const filterRows = this.filterList.getElementsByClassName('filter-row');
    for (let i = 0; i < filterRows.length; i++) {
      const li = filterRows[i];
      const subHeight = li.getElementsByClassName('sub-filter-list')[0]
        .clientHeight;
      const liClass = li.className;
      if (subHeight > DEFAULT_ROW_HEIGHT) {
        li.className = liClass.includes('foldable')
          ? liClass
          : `${liClass} foldable`;
      } else {
        li.className = !liClass.includes('foldable')
          ? liClass
          : liClass.replace('foldable', '');
      }
    }
  };

  // sub-filter折叠处理
  handleFolderList(e) {
    const parentNode = e.currentTarget.parentNode;
    const parentClass = parentNode.className;
    if (parentClass.includes('folding')) {
      parentNode.className = parentClass.replace('folding', '');
    } else {
      parentNode.className = `${parentClass} folding`;
    }
  }

  // 选择标签筛选项
  handleSelectTag = (tagId, tags, groupId) => {
    const { selectedFilters, setFilters } = this.props;
    const { tags: selectedTags, type } = selectedFilters;
    let newIds = clone(selectedTags, true);
    let newType = type;
    if (groupId === DEFAULT_FILTER) {
      newType = tagId === ALL_KEY ? '' : tagId;
    } else {
      // 清除该分组下已被选中的筛选项
      const clearIds = tags.map(tag => tag.id);
      newIds = selectedTags.filter(id => !clearIds.includes(id));
      if (tagId !== ALL_KEY) {
        const index = selectedTags.findIndex(id => id === tagId);
        // 切换选中状态
        index === -1 ? newIds.push(tagId) : newIds.splice(index, 1);
      }
    }

    setFilters({ tags: newIds, type: newType });
  };

  // 检查标签是否被全选
  checkHasSelectedTag(tags, groupId) {
    const { tags: selectedTags, type } = this.props.selectedFilters;
    return (
      tags.some(tag => selectedTags.includes(tag.id)) ||
      (groupId === DEFAULT_FILTER && !!type)
    );
  }

  // 过滤空标签
  filterEmptyTags(filters) {
    return filters.filter(item => item.tags?.length > 0);
  }

  // 渲染sub标签
  renderSubFilters(tags, groupId) {
    const { tags: selectedTags, type } = this.props.selectedFilters;
    const hasSelected = tags && this.checkHasSelectedTag(tags, groupId);
    return tags.map(item => {
      const { name, id } = item;
      return (
        <li
          className={cx('sub-filter', {
            active:
              selectedTags.includes(id) ||
              (!hasSelected && id === ALL_KEY) ||
              (groupId === DEFAULT_FILTER && id === type),
          })}
          onClick={() => this.handleSelectTag(id, tags, groupId)}
          key={id + name}>
          {name}
        </li>
      );
    });
  }

  // 渲染筛选项
  renderFilters(filters) {
    return filters.map(item => {
      const { groupName, tags, groupId } = item;
      if (!tags || (Array.isArray(tags) && tags.length < 1)) return '';
      return (
        <li key={groupId + groupName} className="filter-row">
          <span className="filter-title">{groupName}</span>
          <ul className="sub-filter-list">
            {tags && this.renderSubFilters(tags, groupId)}
          </ul>
          <span className="fold-btn" onClick={e => this.handleFolderList(e)}>
            <span className="fold-text"></span>
            <span className="down-arrow" />
          </span>
        </li>
      );
    });
  }

  render() {
    const { filters } = this.props;
    const { isShowMore } = this.state;
    // 计算是否展示查看更多按钮
    const rows = this.filterEmptyTags(filters).length;
    const hasMore = rows > MAX_FILTER_ROW;
    return (
      <div
        className={cx('store-filters-orgzone', {
          folding: isShowMore,
          hasMore,
        })}>
        <ul className="filter-list" ref={c => (this.filterList = c)}>
          {Array.isArray(filters) && filters.length
            ? this.renderFilters(filters)
            : null}
        </ul>
        <div
          className="fold-btn more-btn"
          onClick={() => this.setState({ isShowMore: !isShowMore })}>
          <span className="text">{isShowMore ? '收起' : '查看全部'}</span>
          <span className="down-arrow" />
        </div>
      </div>
    );
  }
}
